import {
  GCPBillingFilters,
  GCPBillingListQuery,
  GCPBillingPagination,
  GCPBillingSort,
} from './types';

export const buildGCPBillingQuery = (
  filters: GCPBillingFilters,
  pagination: GCPBillingPagination,
  sort?: GCPBillingSort
): GCPBillingListQuery => {
  const query: GCPBillingListQuery = {
    page: pagination.page,
    per_page: pagination.perPage,
  };
  const billingId = filters.gcpBillingId.trim();

  if (filters.month) query.month = filters.month;
  if (billingId) query.gcp_billing_id = billingId;
  if (filters.currencies.length) {
    query.currency = filters.currencies.join(',');
  }
  if (filters.invoiceFilter === 'created') {
    query.un_invoiced_only = false;
  }
  if (
    filters.invoiceFilter === 'skipped' ||
    filters.invoiceFilter === 'failed'
  ) {
    query.invoice_status = filters.invoiceFilter;
  }
  if (filters.companyFilter !== 'all') {
    query.company_not_found_only = filters.companyFilter === 'not-found';
  }
  if (sort && sort.sortBy !== null) {
    query[`sort[${sort.sortBy}]`] = sort.sortOrder;
  }

  return query;
};
